import {useBlocker} from "react-router";
import {useTranslations} from "@/context/TranslationProvider";
import {useEffect} from "react";

function disableBeforeUnload() {
    window.onbeforeunload = null;
}

export function useFormGuard(enabled: boolean): void {
    const translations = useTranslations();
    const blocker = useBlocker(
        ({currentLocation, nextLocation}) => enabled && currentLocation.pathname !== nextLocation.pathname,
    );

    if (enabled) window.onbeforeunload = () => "";
    else disableBeforeUnload();

    useEffect(() => {
        if (blocker.state == "blocked") {
            if (!window.confirm(translations.get("confirm_cancel"))) {
                disableBeforeUnload();
                blocker.reset();
            } else blocker.proceed();
        }
        // we do not want the whole blocker as dependency, just the state - eslint does not like this
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [blocker.state, translations]);
}
